import { render, staticRenderFns } from "./pieEchart.vue?vue&type=template&id=63f4d45a&"
import script from "./pieEchart.vue?vue&type=script&lang=js&"
export * from "./pieEchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports